import { render, staticRenderFns } from "./sv-panel.vue?vue&type=template&id=d8583596&"
import script from "./sv-panel.vue?vue&type=script&lang=js&"
export * from "./sv-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8583596')) {
      api.createRecord('d8583596', component.options)
    } else {
      api.reload('d8583596', component.options)
    }
    module.hot.accept("./sv-panel.vue?vue&type=template&id=d8583596&", function () {
      api.rerender('d8583596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/color-picker/src/components/sv-panel.vue"
export default component.exports